import { BuildInfo } from "@prism/prism-shared"; 
        
export const buildInfo: BuildInfo = { 
    commitHash: 'c0c89b2ac98c1dbfd5f5d8b43fbbce68b9956f32', 
    deploymentTimestamp: 1793820890173,
    user: 'steven woerpel',
    deploymentId: 'c0c89b2a-mw2in58d',
}
